// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.events-page-main .wpb_wrapper.head {
    height: 550px; 
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.events-page-main .wpb_wrapper.head .event-slideshow {
    height: 56.25vh;
    width: 70%; 
    display: flex;
    overflow: hidden;
    object-fit: contain;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);   
    border-radius: 1%;
}

.event-slideshow img {
    width: 100%; 
    height: 50vh;      
    object-fit: cover; 
 
}

.event-slideshow .carousel-caption {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    text-align: center;
    background-color: transparent; 
    padding: 10px; 
    color: white; 
}


.carousel-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3); 
}

.carousel-caption {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    color: #fff; 
}

.event-info {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.event-name {
    color: white;
    text-align: center; /* Adjust alignment as needed */
    margin-bottom: 10px; /* Adjust spacing as needed */
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Two columns of equal width */
    gap: 20px; /* Space between columns */
    justify-content: center; /* Center content along the horizontal axis */
    margin: 0 auto; /* Center the grid on the page */    
    max-width: 1000px; /* Maximum width of the grid */
}

.grid-item {
    position: relative;
    width: 100%; /* Ensure each item occupies the full width of the column */
    max-width: 500px; /* Maximum width for each item */
    border-radius: 5%;
}

.image-container {
    position: relative;
}

.grid-image {
    display: block;
    width: 100%; /* Ensure the image occupies the full width of its container */
    height: auto; /* Maintain aspect ratio */
    border-radius: 5%;
}

.grid-item:hover .grid-image {
    transition: transform 0.3s ease;
    transform: scale(1.05); /* Scale the image on hover */
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3); /* Background opacity */
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0; /* The overlay is hidden by default */
    transition: opacity 0.3s ease; /* Fade effect */
    border-radius: 5%;
}

.image-container:hover .overlay {
    opacity: 1;
    transform: scale(1.04);
}

.button-on-hover {
    padding: 10px 20px;
    background-color: #e0dcdc;
    color: #000000;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: 5%;
}

.button-on-hover:hover {
    background-color: #cccccc;
}

@media screen and (max-width: 768px) {
    .event-details-align{
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
}

.adult-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle; /* Aligns the icon with the middle of the text */
    background-image: url('https://w7.pngwing.com/pngs/636/585/png-transparent-computer-icons-encapsulated-postscript-symbol-eighteen-miscellaneous-text-trademark-thumbnail.png'); /* Replace with the path to your icon */
    background-size: cover;
    margin-left: 5px; /* Adds some space between the text and the icon */
  }

  @media (max-width: 768px) {
    .carousel-caption {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .events-item {
      margin-left: 5%;
      margin-right: 5%;
    }
  }

  .container-images {
    margin-top: 15px;
    position: relative;
    min-height: 15px;
    background: #e6e3e3;
    width: 100%; 
  }
  
  .container-images h1 {
    font-size: 20px;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-weight: 15px; 
    color: #333;
    text-align: center;
    text-transform: capitalize;
  }
  
  .container-images .container-images-details {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    padding: 10px;
  }
  
  .container-images .container-images-details .image-container {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(25% - 10px); 
    max-width: calc(25% - 30px); 
    height: auto; 
    border: 7px solid #fff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .1);
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 10px; 
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .container-images .container-images-details .image-container .image-in-container {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform .2s linear;
    
  }
  
  .container-images .container-images-details .image-container:hover .image-in-container {
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    .container-images .container-images-details .image-container {
      flex-basis: calc(50% - 10px);
      max-width: calc(50% - 10px); 
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/events/events_page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,6BAA6B;IAC7B,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB,EAAE,+BAA+B;IACnD,mBAAmB,EAAE,6BAA6B;AACtD;;AAEA;IACI,aAAa;IACb,qCAAqC,EAAE,+BAA+B;IACtE,SAAS,EAAE,0BAA0B;IACrC,uBAAuB,EAAE,6CAA6C;IACtE,cAAc,EAAE,gCAAgC;IAChD,iBAAiB,EAAE,8BAA8B;AACrD;;AAEA;IACI,kBAAkB;IAClB,WAAW,EAAE,2DAA2D;IACxE,gBAAgB,EAAE,gCAAgC;IAClD,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW,EAAE,8DAA8D;IAC3E,YAAY,EAAE,0BAA0B;IACxC,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB,EAAE,6BAA6B;AACzD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,uBAAuB;IAC7D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU,EAAE,qCAAqC;IACjD,6BAA6B,EAAE,gBAAgB;IAC/C,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB,EAAE,gDAAgD;IACxE,8KAA8K,EAAE,uCAAuC;IACvN,sBAAsB;IACtB,gBAAgB,EAAE,kDAAkD;EACtE;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gDAAgD;IAChD,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;IACtB,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;;EAElC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,4BAA4B;MAC5B,2BAA2B;IAC7B;EACF","sourcesContent":[".events-page-main .wpb_wrapper.head {\n    height: 550px; \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.events-page-main .wpb_wrapper.head .event-slideshow {\n    height: 56.25vh;\n    width: 70%; \n    display: flex;\n    overflow: hidden;\n    object-fit: contain;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);   \n    border-radius: 1%;\n}\n\n.event-slideshow img {\n    width: 100%; \n    height: 50vh;      \n    object-fit: cover; \n \n}\n\n.event-slideshow .carousel-caption {\n    position: absolute;\n    top: 50%;\n    transform: translate(0, -50%);\n    text-align: center;\n    background-color: transparent; \n    padding: 10px; \n    color: white; \n}\n\n\n.carousel-item::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.3); \n}\n\n.carousel-caption {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 20px;\n    color: #fff; \n}\n\n.event-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.event-name {\n    color: white;\n    text-align: center; /* Adjust alignment as needed */\n    margin-bottom: 10px; /* Adjust spacing as needed */\n}\n\n.image-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* Two columns of equal width */\n    gap: 20px; /* Space between columns */\n    justify-content: center; /* Center content along the horizontal axis */\n    margin: 0 auto; /* Center the grid on the page */    \n    max-width: 1000px; /* Maximum width of the grid */\n}\n\n.grid-item {\n    position: relative;\n    width: 100%; /* Ensure each item occupies the full width of the column */\n    max-width: 500px; /* Maximum width for each item */\n    border-radius: 5%;\n}\n\n.image-container {\n    position: relative;\n}\n\n.grid-image {\n    display: block;\n    width: 100%; /* Ensure the image occupies the full width of its container */\n    height: auto; /* Maintain aspect ratio */\n    border-radius: 5%;\n}\n\n.grid-item:hover .grid-image {\n    transition: transform 0.3s ease;\n    transform: scale(1.05); /* Scale the image on hover */\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.3); /* Background opacity */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    opacity: 0; /* The overlay is hidden by default */\n    transition: opacity 0.3s ease; /* Fade effect */\n    border-radius: 5%;\n}\n\n.image-container:hover .overlay {\n    opacity: 1;\n    transform: scale(1.04);\n}\n\n.button-on-hover {\n    padding: 10px 20px;\n    background-color: #e0dcdc;\n    color: #000000;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    border-radius: 5%;\n}\n\n.button-on-hover:hover {\n    background-color: #cccccc;\n}\n\n@media screen and (max-width: 768px) {\n    .event-details-align{\n        flex-direction: column;\n        align-items: center;\n        gap: 1rem;\n    }\n}\n\n.adult-icon {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    vertical-align: middle; /* Aligns the icon with the middle of the text */\n    background-image: url('https://w7.pngwing.com/pngs/636/585/png-transparent-computer-icons-encapsulated-postscript-symbol-eighteen-miscellaneous-text-trademark-thumbnail.png'); /* Replace with the path to your icon */\n    background-size: cover;\n    margin-left: 5px; /* Adds some space between the text and the icon */\n  }\n\n  @media (max-width: 768px) {\n    .carousel-caption {\n      display: none;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .events-item {\n      margin-left: 5%;\n      margin-right: 5%;\n    }\n  }\n\n  .container-images {\n    margin-top: 15px;\n    position: relative;\n    min-height: 15px;\n    background: #e6e3e3;\n    width: 100%; \n  }\n  \n  .container-images h1 {\n    font-size: 20px;\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    font-weight: 15px; \n    color: #333;\n    text-align: center;\n    text-transform: capitalize;\n  }\n  \n  .container-images .container-images-details {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px;\n    padding: 10px;\n  }\n  \n  .container-images .container-images-details .image-container {\n    flex: 1 1 calc(25% - 10px); \n    max-width: calc(25% - 30px); \n    height: auto; \n    border: 7px solid #fff;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, .1);\n    overflow: hidden;\n    cursor: pointer;\n    margin-bottom: 10px; \n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .container-images .container-images-details .image-container .image-in-container {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform .2s linear;\n    \n  }\n  \n  .container-images .container-images-details .image-container:hover .image-in-container {\n    transform: scale(1.1);\n  }\n  \n  @media (max-width: 768px) {\n    .container-images .container-images-details .image-container {\n      flex-basis: calc(50% - 10px);\n      max-width: calc(50% - 10px); \n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
